import React from "react";
import { getStatisticsFromOrigin } from "../helpers/requestHandler";

import PieChart, { Series, Label, Connector, Tooltip, Legend, Font, Export, } from 'devextreme-react/pie-chart';
import { Card } from "react-bootstrap";

class PieChartActiveUsers extends React.Component {
  constructor(props) {
    super(props);
    this.options = null;
    this.state = {
      getData: [],
      errorMessage: ""
    };
    this.pointClickHandler = this.pointClickHandler.bind(this);
    this.legendClickHandler = this.legendClickHandler.bind(this);
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Statistic/GetActiveUsersByInstanceRange")
    if(resp) {
      let respForm = resp.sort(function(a, b) { return a.count < b.count ? 1 : -1; })
      .slice(0, 5);
      
      this.setState({ getData: respForm});
    }
  }

  render() { 
    if(this.state.getData !== null) {
        return (
          <Card className="rounded-4">
            <Card.Body>
              <Card.Title>
                  Active Users (Top 5 - {global.config.dashboard.range} Days)
              </Card.Title>
              <Card.Subtitle>
                    Number of Active User Logins based on selected range
                </Card.Subtitle>
              <PieChart
                  id="pie"
                  type="doughnut"
                  title=""
                  innerRadius={0.7}
                  palette="Dark Violet"
                  dataSource={this.state.getData}
                  resolveLabelOverlapping="shift" 
                  precision= {2}
              >
              <Export enabled={true} />
              <Legend visible={false} /> 
              <Series argumentField="instance" valueField="count">
                <Label
                  customizeText={this.customizeLabel}
                  backgroundColor="none"
                  visible={true}
                  position="columns">
                  <Font size={14} />
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
              <Tooltip enabled={true} zIndex={10000} customizeTooltip={this.customizeTooltip}>
              </Tooltip>
            </PieChart>
          </Card.Body>
        </Card>
        );
    }
  }

  customizeLabel(e) {
    return `${e.argumentText}\n${e.valueText}`;
  }

  customizeTooltip(arg) {
    return {
      text: `${arg.argumentText} - ${(arg.percent * 100).toFixed(2)}%`,
    };
  }

  pointClickHandler(e) {
    this.toggleVisibility(e.target);
  }

  legendClickHandler(e) {
    const arg = e.target;
    const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

    this.toggleVisibility(item);
  }

  toggleVisibility(item) {
    item.isVisible() ? item.hide() : item.show();
  }
}

export default PieChartActiveUsers;